import React from 'react';
import { useParams, Link } from 'react-router-dom';

function BlogDetail() {
  const { id } = useParams();
  
  const blogs = {
    1: {
      title: 'How React Powers Performance, Scalability, and User-Centered Design',
      date: '17 April 2026',
      content: [
        'Modern web development demands performance, scalability, and user-centered design. Here\'s how React enables all three.',
        'React has become one of the most widely used JavaScript libraries for building modern web applications and for good reason. Its component-based architecture allows developers to break down complex interfaces into reusable, manageable pieces. This not only improves development speed but also ensures consistency across large-scale applications.',
        'One of React\'s greatest strengths is its ability to handle dynamic user interfaces efficiently. Through the use of a virtual DOM, React minimizes direct interactions with the browser\'s actual DOM, resulting in faster rendering and a smoother user experience. This is especially important for applications that handle large amounts of data or require real-time updates.',
        'Scalability is another area where React shines. As applications grow, maintaining code quality becomes increasingly challenging. React addresses this by promoting a clear structure and separation of concerns. With tools like hooks and state management libraries such as Redux or Context API, developers can manage complex state logic in a predictable and organized way.',
        'In addition, React\'s vast ecosystem makes it highly adaptable. Whether integrating APIs, optimizing performance, or deploying applications, developers have access to a wide range of libraries and tools that extend React\'s capabilities. Frameworks like Next.js further enhance scalability by enabling server-side rendering and improved SEO performance.',
        'User-centered design is at the core of React development. By creating interactive and responsive interfaces, developers can focus on delivering seamless user experiences. React\'s flexibility allows teams to quickly test, iterate, and improve features based on user feedback.',
        'In conclusion, React is more than just a library it is a powerful tool for building scalable, high-performance web applications. By leveraging its component-based structure, efficient rendering, and rich ecosystem, developers can create solutions that not only meet today\'s demands but are also prepared for future growth.'
      ]
    },
    2: {
      title: 'Service Over Status: A Practical View of True Leadership',
      date: '17 April 2026',
      content: [
        'True leadership means listening, adapting, and uplifting others.',
        'In many contexts, leadership is often associated with authority, titles, and control. However, true leadership goes beyond status it is rooted in service. It is about putting the needs of others first, creating opportunities for growth, and building an environment where everyone feels valued and heard.',
        'From my experience working with diverse groups and communities, I have come to understand leadership in a more meaningful way. Leadership is not about giving orders, but about listening. Each individual brings a unique perspective, and taking the time to understand those perspectives allows for more thoughtful and inclusive decisions.',
        'Service-oriented leadership also requires adaptability. In fast-changing environments, challenges arise unexpectedly. A strong leader remains flexible, open to change, and willing to adjust approaches when needed. This ensures that solutions are not only effective but also sustainable in the long term.',
        'Another key aspect of leadership is uplifting others. True leaders empower those around them by recognizing their potential and creating opportunities for them to grow. Encouragement and support can build confidence and inspire individuals to take initiative, making leadership a shared journey rather than a one-person role.',
        'Moreover, service-driven leadership builds trust. When people see that a leader is genuinely committed to their well-being, they are more likely to engage, collaborate, and contribute meaningfully. Trust becomes the foundation for strong teams and lasting impact.',
        'In conclusion, leadership is not defined by titles or recognition, but by impact. It is about serving others with humility, leading with empathy, and creating meaningful change. The most effective leaders are those who choose service over status.'
      ]
    }
  };

  const blog = blogs[id];

  if (!blog) {
    return (
      <div className="container" style={{padding: '8rem 2rem', textAlign: 'center'}}>
        <h2>Blog not found</h2>
        <Link to="/blogs" className="btn btn-primary" style={{marginTop: '2rem'}}>Back to Blogs</Link>
      </div>
    );
  }

  return (
    <>
      <section className="blog-detail-hero">
        <div className="blog-detail-hero-video">
          <iframe 
            width="100%" 
            height="100%" 
            src="https://www.youtube.com/embed/ttYCPcxcSzE?autoplay=1&mute=1&loop=1&playlist=ttYCPcxcSzE" 
            title="YouTube video player" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowFullScreen
          ></iframe>
        </div>
        <div className="blog-detail-overlay"></div>
        <div className="blog-detail-header">
          <h1>{blog.title}</h1>
          <p className="blog-detail-date">{blog.date}</p>
        </div>
      </section>

      <section className="blog-detail-content">
        <div className="container">
          <Link to="/blogs" className="back-link">← Back to Blogs</Link>
          <article className="blog-article">
            {blog.content.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </article>
        </div>
      </section>
    </>
  );
}

export default BlogDetail;
